<template>
  <section>
    <gs-header title="Sửa quận huyện"
      :breadcrumbs="[
        {title: 'Quản lý quận huyện', route: {name: 'district'}}
      ]"
    >
    </gs-header>
    <div class="padding-all" v-if="localDistrict.id">
      <el-form :model="localDistrict" :rules="rules" ref="createCityForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitCity('createCityForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Chọn tỉnh thành" prop="city_id">
              <el-select v-model="localDistrict.city_id" filterable placeholder="Chọn tỉnh thành" class="width-100">
                <el-option
                  label="Chọn tỉnh thành"
                  :value="0"
                >
                </el-option>
                <el-option
                  v-for="city in cities"
                  :key="city.id"
                  :label="city.name"
                  :value="city.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mã bưu chính " prop="code">
              <el-input v-model="localDistrict.code" placeholder="Mã bưu chính"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localDistrict.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tên viết tắt" prop="short_name">
              <el-input v-model="localDistrict.short_name" placeholder="Tên viết tắt"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-for="(carrier, index) in listCarriers" :key="index">
            <el-form-item :label="carrier.name" :key="localDistrict[carrier.key]">
              <el-input v-model="localDistrict[carrier.key]" :placeholder="carrier.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Các loại tên" prop="map_name">
              <el-select
                v-model="mapNames"
                multiple
                filterable
                allow-create
                default-first-option
                :reserve-keyword="false"
                placeholder="Chọn các loại tên cho quận huyện"
                style="width: 100%"
                no-data-text="Không có dữ liệu"
                @change="handleChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Loại quận huyện đi" prop="kind_from">
              <el-select v-model="localDistrict.kind_from" filterable placeholder="Loại quận huyện đi" class="width-100">
                <el-option
                  label="Loại quận huyện đi"
                  :value="0"
                >
                </el-option>
                <el-option
                  v-for="(kind, index) in districtKind"
                  :key="index"
                  :label="kind"
                  :value="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Loại quận huyện đến" prop="kind_to">
              <el-select v-model="localDistrict.kind_to" filterable placeholder="Loại quận huyện đến" class="width-100">
                <el-option
                  label="Loại quận huyện đến"
                  :value="0"
                >
                </el-option>
                <el-option
                  v-for="(kind, index) in districtKind"
                  :key="index"
                  :label="kind"
                  :value="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <p>Hãng vận chuyển</p>
        </el-row>
        <el-row :gutter="20" v-for="(carrier, index) in carriers" :key="carrier.id" v-if="Object.keys(dataCarriers).length">
          <el-col :span="20" :offset="2">
            <el-row :gutter="20" v-if="dataCarriers[carrier.short_name]">
              <el-col :span="4">
                <el-form-item>
                  <el-checkbox v-model="defaultCarriers[carrier.short_name]" @change="pushCarrier(carrier)">{{carrier.name}}</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item>
                  <el-select :disabled="!defaultCarriers[carrier.short_name]"  v-model="dataCarriers[carrier.short_name].kind_from" filterable placeholder="Loại quận huyện đi" class="width-100">
                    <el-option
                      label="Loại quận huyện đi"
                      :value="0"
                    >
                    </el-option>
                    <el-option
                      v-for="(kind, index) in districtKind"
                      :key="index"
                      :label="kind"
                      :value="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item>
                  <el-select :disabled="!defaultCarriers[carrier.short_name]" v-model="dataCarriers[carrier.short_name].kind_to" filterable placeholder="Loại quận huyện đến" class="width-100">
                    <el-option
                      label="Loại quận huyện đến"
                      :value="0"
                    >
                    </el-option>
                    <el-option
                      v-for="(kind, index) in districtKind"
                      :key="index"
                      :label="kind"
                      :value="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { editDistrict, getDistrict } from 'src/api/district'
import { head, forEach } from 'lodash'
import mixins from './mixins'
export default {
  name: 'EditDistrict',
  mixins: [mixins],
  methods: {
    validateBeforeSubmitCity () {
      this.submitting = true
      this.toggleLoadding()
      let carriers = []
      forEach(this.dataCarriers, carrier => {
        if (carrier.id && carrier.kind_from !== 0 && carrier.kind_to !== 0) {
          carriers.push(carrier)
        }
      })
      this.localDistrict.carriers = carriers
      this.localDistrict.map_names = this.mapNames
      this.$refs.createCityForm.validate(valid => {
        if (valid) {
          this.changedData = false
          editDistrict(this.localDistrict.id, this.localDistrict).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa quận huyện  thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'district'}, 'districts')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Sửa thất bại',
                  body: 'Sửa quận huyện thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    }
  },
  mounted () {
    getDistrict(this.$route.params.id, {include: 'carriers'}).then(response => {
      if (response.code === 200) {
        this.localDistrict.id = response.data.id
        this.localDistrict.city_id = response.data.city_id
        this.localDistrict.name = response.data.name
        this.localDistrict.short_name = response.data.short_name
        this.localDistrict.code = response.data.code
        this.mapNames = response.data && response.data.map_names ? response.data.map_names : []
        this.options = this.mapNames.map((value) => ({
          value,
          label: value,
        }))
        forEach(this.listCarriers, value => {
          this.localDistrict[value.key] = response.data[value.key]
        })
        this.localDistrict.kind_from = response.data.kind_from.toString()
        this.localDistrict.kind_to = response.data.kind_to.toString()
        forEach(response.data.carriers.data, carrier => {
          this.dataCarriers[carrier.short_name] = {
            id: carrier.id,
            kind_from: carrier.kind_from.toString(),
            kind_to: carrier.kind_to.toString()
          }
          this.defaultCarriers[carrier.short_name] = true
        })
        setTimeout(() => {
          this.watching = true
        }, 100)
      } else {
        this.$router.push({name: 'carrier'})
        this.$store.dispatch('showNotify', {
          title: 'Vui lòng kiểm tra thông tin cần nhập',
          body: 'Không tìm thấy tài nguyên',
          type: 'warning'
        })
      }
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// EditDistrict.vue?a63c166a